module.exports = __webpack_public_path__ + "img/wrong-data.51bbe86b.png";